/* SX – interakcje motywu (nakładka na Shrine PRO) */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(type) {
    try { return window[type]; } catch (e) { return null; }
  }

  /* ---------- Pauza animacji przy ukrytej karcie ---------- */
  function onVisibility() {
    root.classList.toggle('sx-tab-hidden', document.hidden);
  }
  document.addEventListener('visibilitychange', onVisibility);
  onVisibility();

  /* ---------- Reveal przy scrollu ---------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.sx-reveal:not(.is-in)');
    els.forEach(function (el) {
      if (!revealObserver || reduceMotion) { el.classList.add('is-in'); return; }
      revealObserver.observe(el);
    });
  }

  /* ---------- Karuzela wideo ---------- */
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-sx-videos]').forEach(function (wrap) {
      if (wrap.dataset.sxInit) return;
      wrap.dataset.sxInit = '1';
      var track = wrap.querySelector('[data-sx-track]');
      var videos = wrap.querySelectorAll('video');

      if ('IntersectionObserver' in window) {
        var vo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && !document.hidden) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.5 });
        videos.forEach(function (v) {
          v.muted = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          vo.observe(v);
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) videos.forEach(function (v) { v.pause(); });
      });

      function step(dir) {
        if (!track) return;
        var card = track.querySelector('[data-sx-slide]');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
        var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var prev = wrap.querySelector('[data-sx-prev]');
      var next = wrap.querySelector('[data-sx-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var dots = wrap.querySelectorAll('[data-sx-dot]');
      if (track && dots.length) {
        var raf;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var slides = track.querySelectorAll('[data-sx-slide]');
            if (!slides.length) return;
            var w = slides[0].getBoundingClientRect().width + 14;
            var idx = Math.round(track.scrollLeft / w);
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          });
        }, { passive: true });
      }
    });
  }

  /* ---------- Jak grać: linia ---------- */
  function initSteps(scope) {
    (scope || document).querySelectorAll('[data-sx-steps]').forEach(function (el) {
      if (!('IntersectionObserver' in window) || reduceMotion) { el.classList.add('is-in'); return; }
      var o = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { el.classList.add('is-in'); o.disconnect(); }
        });
      }, { threshold: 0.25 });
      o.observe(el);
    });
  }

  /* ---------- Opinie: Pokaż więcej ---------- */
  function initReviews(scope) {
    (scope || document).querySelectorAll('[data-sx-reviews]').forEach(function (wrap) {
      if (wrap.dataset.sxInit) return;
      wrap.dataset.sxInit = '1';
      var btn = wrap.querySelector('[data-sx-more]');
      var step = parseInt(wrap.dataset.step, 10) || 6;
      if (!btn) return;
      btn.addEventListener('click', function () {
        var hidden = wrap.querySelectorAll('[data-sx-review][hidden]');
        for (var i = 0; i < hidden.length && i < step; i++) {
          hidden[i].hidden = false;
          hidden[i].classList.remove('is-in');
          hidden[i].style.setProperty('--sx-i', i % 6);
          initReveal(hidden[i].parentNode);
        }
        if (wrap.querySelectorAll('[data-sx-review][hidden]').length === 0) btn.hidden = true;
      });
    });
  }

  /* ---------- Banner podglądu opinii (edytor) ---------- */
  function initAdminNote(scope) {
    (scope || document).querySelectorAll('[data-sx-admin-note]').forEach(function (note) {
      var ss = store('sessionStorage');
      var key = 'sx-note-' + (note.dataset.id || '');
      try { if (ss && ss.getItem(key) === '1') note.hidden = true; } catch (e) {}
      var b = note.querySelector('button');
      if (b) b.addEventListener('click', function () {
        note.hidden = true;
        try { if (ss) ss.setItem(key, '1'); } catch (e) {}
      });
    });
  }

  /* ---------- Przewijanie do produktu ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sx-to-product], a[href="#produkt"]');
    if (!link) return;
    var target = document.querySelector('[id^="MainProduct-"]') || document.querySelector('.product');
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Cart drawer: pasek darmowej dostawy ---------- */
  function runFreeShipping(drawer, force) {
    var bar = drawer.querySelector('.sx-fs');
    if (!bar) return;
    var count = parseInt(bar.dataset.count, 10) || 0;
    if (count < 1) return;
    if (bar.dataset.sxDone && !force) return;
    bar.dataset.sxDone = '1';

    if (reduceMotion) { bar.classList.add('is-static', 'is-done'); return; }

    bar.classList.remove('is-run', 'is-done', 'is-static');
    bar.querySelectorAll('.sx-fs__spark').forEach(function (s) { s.remove(); });
    void bar.offsetWidth; // restart transition
    bar.classList.add('is-run');

    clearTimeout(bar._sxT);
    bar._sxT = setTimeout(function () {
      bar.classList.add('is-done');
      if (bar.dataset.sparkle === 'false') return;
      var track = bar.querySelector('.sx-fs__track');
      if (!track) return;
      var rect = track.getBoundingClientRect();
      var box = bar.getBoundingClientRect();
      for (var i = 0; i < 12; i++) {
        var s = document.createElement('span');
        s.className = 'sx-fs__spark';
        s.style.left = (rect.right - box.left - 6) + 'px';
        s.style.top = (rect.top - box.top + 1) + 'px';
        var ang = Math.random() * Math.PI * 2;
        var dist = 18 + Math.random() * 30;
        s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
        s.style.setProperty('--dy', Math.sin(ang) * dist * 0.7 + 'px');
        s.style.animationDelay = (Math.random() * 0.15) + 's';
        bar.appendChild(s);
      }
    }, 1200);
  }

  function initCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.sxObs) return;
    drawer.dataset.sxObs = '1';
    var wasActive = drawer.classList.contains('active');
    if (wasActive) runFreeShipping(drawer, true);

    new MutationObserver(function () {
      var active = drawer.classList.contains('active');
      if (active && !wasActive) {
        var bar = drawer.querySelector('.sx-fs');
        if (bar) delete bar.dataset.sxDone;
        runFreeShipping(drawer, true);
      }
      wasActive = active;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Treść koszyka podmieniana przez AJAX – nowy pasek, gdy szuflada otwarta
    new MutationObserver(function (muts) {
      if (!drawer.classList.contains('active')) return;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1 || n.classList.contains('sx-fs__spark')) continue;
          if (n.classList.contains('sx-fs') || (n.querySelector && n.querySelector('.sx-fs'))) {
            runFreeShipping(drawer, false);
            return;
          }
        }
      }
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- Licznik w pasku promocji (czas polski) ---------- */
  function warsawOffsetMs(at) {
    try {
      var p = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Warsaw', hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(at).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
      var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      return asUtc - Math.floor(at.getTime() / 1000) * 1000;
    } catch (e) { return 0; }
  }

  function timerTarget(el) {
    var now = new Date();
    var off = warsawOffsetMs(now);
    if (el.dataset.mode === 'date') {
      var m = (el.dataset.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return null;
      var local = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
      return local - off;
    }
    var w = new Date(now.getTime() + off); // „zegar” warszawski w polach UTC
    var midnight = Date.UTC(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate() + 1, 0, 0, 0);
    return midnight - off;
  }

  function initTimers(scope) {
    (scope || document).querySelectorAll('[data-sx-timer]').forEach(function (el) {
      if (el.dataset.sxInit) return;
      el.dataset.sxInit = '1';
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var dot = el.previousElementSibling;
      function tick() {
        var target = timerTarget(el);
        var left = target === null ? -1 : Math.floor((target - Date.now()) / 1000);
        if (left < 0) {
          el.hidden = true;
          if (dot && dot.classList.contains('sx-promo__dot')) dot.hidden = true;
          if (el.dataset.mode === 'date') return clearInterval(el._sxI);
          return;
        }
        el.hidden = false;
        if (dot) dot.hidden = false;
        var hh = Math.floor(left / 3600);
        h.textContent = pad(hh);
        m.textContent = pad(Math.floor((left % 3600) / 60));
        s.textContent = pad(left % 60);
      }
      tick();
      el._sxI = setInterval(tick, 1000);
    });
  }

  /* ---------- Opinie z importu (sx-reviews-feed) ---------- */
  function initReviewsFeed(scope) {
    (scope || document).querySelectorAll('[data-sx-rf]').forEach(function (sec) {
      if (sec.dataset.sxInit) return;
      sec.dataset.sxInit = '1';
      var data = [], photos = {};
      try { data = JSON.parse((sec.querySelector('[data-sx-rf-data]') || {}).textContent || '[]'); } catch (e) { data = []; }
      try { photos = JSON.parse((sec.querySelector('[data-sx-rf-photos]') || {}).textContent || '{}'); } catch (e) { photos = {}; }
      if (!data.length) return;
      data.forEach(function (r) { var o = photos[(r.n || '').trim()]; if (o) r.i = o; });

      var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var stars = function (n) { n = Math.round(n); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); };
      var fmtDate = function (d) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || ''); return m ? m[3] + '.' + m[2] + '.' + m[1] : (d || ''); };

      // podsumowanie
      var sum = 0, dist = [0, 0, 0, 0, 0, 0];
      data.forEach(function (r) { var v = Math.max(1, Math.min(5, +r.r || 5)); sum += v; dist[v]++; });
      var avg = sum / data.length;
      var summary = sec.querySelector('[data-sx-rf-summary]');
      sec.querySelector('[data-sx-rf-avg]').textContent = avg.toFixed(1).replace('.', ',');
      sec.querySelector('[data-sx-rf-avgstars]').textContent = stars(avg);
      var cnt = sec.querySelector('[data-sx-rf-count]');
      cnt.textContent = (cnt.dataset.label || '[count]').replace('[count]', String(data.length));
      var bars = '';
      for (var s = 5; s >= 1; s--) {
        var p = Math.round(dist[s] / data.length * 100);
        bars += '<div class="sx-rf__bar"><span>' + s + ' ★</span><span class="sx-rf__track"><span class="sx-rf__fill" style="display:block;width:' + p + '%"></span></span><span>' + dist[s] + '</span></div>';
      }
      sec.querySelector('[data-sx-rf-bars]').innerHTML = bars;
      summary.hidden = false;
      sec.querySelector('[data-sx-rf-toolbar]').hidden = false;

      var grid = sec.querySelector('[data-sx-rf-grid]');
      var more = sec.querySelector('[data-sx-rf-more]');
      var verified = grid.dataset.verified || '';
      var initial = parseInt(sec.dataset.initial, 10) || 9;
      var step = parseInt(sec.dataset.step, 10) || 9;
      var shown = 0, list = data.slice();

      function card(r) {
        var init = esc((r.n || '?').trim().charAt(0).toUpperCase());
        return '<article class="sx-rf__card sx-card">' +
          '<div class="sx-rf__top"><span class="sx-rf__avatar" aria-hidden="true">' + init + '</span>' +
          '<div class="sx-rf__who"><span class="sx-rf__name">' + esc(r.n) + '</span>' + (r.v && verified ? '<span class="sx-rf__ver">✓ ' + esc(verified) + '</span>' : '') + '</div>' +
          '<span class="sx-rf__cstars" aria-label="' + (+r.r || 5) + '/5">' + stars(+r.r || 5) + '</span></div>' +
          '<p class="sx-rf__text">' + esc(r.t) + '</p>' +
          (r.i ? '<img class="sx-rf__img" src="' + esc(r.i) + '" alt="" loading="lazy" width="600" height="600">' : '') +
          (r.d ? '<span class="sx-rf__date">' + esc(fmtDate(r.d)) + '</span>' : '') +
          '</article>';
      }
      function render(reset) {
        if (reset) { grid.innerHTML = ''; shown = 0; }
        var next = list.slice(shown, shown + (shown ? step : initial));
        grid.insertAdjacentHTML('beforeend', next.map(card).join(''));
        shown += next.length;
        more.hidden = shown >= list.length;
      }
      function sortBy(mode) {
        list = data.slice();
        if (mode === 'best') list.sort(function (a, b) { return (b.r - a.r) || String(b.d).localeCompare(String(a.d)); });
        else if (mode === 'photo') list.sort(function (a, b) { return (b.i ? 1 : 0) - (a.i ? 1 : 0) || String(b.d).localeCompare(String(a.d)); });
        else list.sort(function (a, b) { return String(b.d).localeCompare(String(a.d)); });
        render(true);
      }
      sec.querySelector('[data-sx-rf-sort]').addEventListener('change', function (e) { sortBy(e.target.value); });
      more.addEventListener('click', function () { render(false); });
      sortBy('new');
    });
  }

  /* ---------- Start ---------- */
  function initAll(scope) {
    initReveal(scope);
    initVideos(scope);
    initSteps(scope);
    initReviews(scope);
    initAdminNote(scope);
    initTimers(scope);
    initReviewsFeed(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initCartDrawer(); });
  } else {
    initAll();
    initCartDrawer();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    initCartDrawer();
  });
})();
